import './animations/bar-chart-animation';
import './animations/bubble-animation';
import './animations/fade-in-animation';
import './animations/clip-animation';
import './animations/pie-animation';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts/dist/es/chart/animations.js
// module id = 2407
// module chunks = 29